import React, { useRef, useEffect, useState } from 'react';
import './App.css';
import Footer from './Footer';

const images = [
  './images/anu1.webp',
  './images/anu2.webp',
  './images/anu3.jpg',
  './images/anu.webp',

];

const TravelForm = () => {
  const carouselRef = useRef(null);
  const [lang, setLang] = useState('en');

  useEffect(() => {
    const scrollInterval = setInterval(() => {
      if (carouselRef.current) {
        const container = carouselRef.current;
        const maxScrollLeft = container.scrollWidth - container.clientWidth;

        if (container.scrollLeft >= maxScrollLeft) {
          container.scrollLeft = 0;
        } else {
          container.scrollLeft += 260;
        }
      }
    }, 2000);

    return () => clearInterval(scrollInterval);
  }, []);

const content = {
  en: `Anuradhapura, located in the North Central Province of Sri Lanka, is a sacred city and one of the oldest continuously inhabited settlements in the world. As the first ancient capital of Sri Lanka, it is revered for its deep-rooted Buddhist heritage and architectural marvels.

Tourists can visit the sacred Jaya Sri Maha Bodhi, a sapling of the original Bodhi tree under which the Buddha attained enlightenment. Just nearby is the Ruwanwelisaya Stupa, an iconic white dagoba symbolizing spiritual power and unity.

Other must-see sites include:
- Abhayagiri Monastery, once one of the world’s greatest centers of Buddhist learning.
- Thuparamaya, the first stupa built in Sri Lanka after the introduction of Buddhism.
- Jetavanaramaya, one of the tallest brick structures of the ancient world.
- Isurumuniya Temple, famous for its rock carvings and the "Lovers" sculpture.
- Kuttam Pokuna (Twin Ponds), showcasing ancient hydraulic engineering.

Surrounded by serene tanks (reservoirs) and ancient ruins, Anuradhapura offers a peaceful, spiritual journey through the golden age of Sri Lankan civilization.`,

  zh: `阿努拉德普勒位于斯里兰卡的北中省，是一个神圣的城市，也是世界上最古老的持续有人居住的定居点之一。作为斯里兰卡的第一个古都，它因深厚的佛教遗产和建筑奇迹而备受尊崇。

游客可以参观神圣的斯里玛哈菩提树，这是释迦牟尼佛成道菩提树的分支。此外，标志性的卢安维利舍亚大佛塔（Ruwanwelisaya）象征着精神力量与团结。

其他必游景点包括：
- 阿巴雅吉里寺院，曾是世界上最重要的佛教学术中心之一；
- 图帕拉玛舍利塔，斯里兰卡佛教传入后建造的第一座佛塔；
- 杰塔瓦纳拉玛舍利塔，古代世界最高的砖结构之一；
- 伊苏鲁穆尼亚寺，以“恋人”雕刻而闻名；
- 库塔姆·波库纳（双池），展现古代的水利工程。

阿努拉德普勒被宁静的水库和古代遗迹环绕，为游客带来一段穿越斯里兰卡文明黄金时代的心灵之旅。`
};


  return (
    <div className="travel-form-container2">
      {/* Row 1 */}
      <div className="row row-one2">
        <div className="col image-col2">
          <img src="./images/anu.webp"  className="travel-image2" />
          <img src="./images/anu3.jpg"  className="travel-image2" />
        </div>

        <div className="col content-col2">
          <h2>Anuradhapura</h2>

          {/* Language Toggle Button */}
          <div style={{ textAlign: 'right', marginBottom: '10px' }}>
            <button onClick={() => setLang(lang === 'en' ? 'zh' : 'en')} style={{ padding: '8px 16px', borderRadius: '6px', border: 'none', backgroundColor: '#967969', color: 'white', cursor: 'pointer' }}>
              {lang === 'en' ? '切换到中文' : 'Switch to English'}
            </button>
          </div>

          {/* Paragraph */}
          <p style={{ whiteSpace: 'pre-line' }}>{content[lang]}</p>
        </div>
      </div>

      {/* Row 2 - Auto Carousel */}
     <div className="carousel-container2">
       <div className="carousel-heading-column">
         <h2 className="carousel-heading">Explore Anuradhapura</h2>
         <p className="carousel-subheading">
           Discover the ancient wonders of Anuradhapura, where sacred relics, colossal stupas, and timeless ruins tell the story of Sri Lanka’s golden Buddhist era.
         </p>
       </div>


       <div className="carousel2" ref={carouselRef}>
         {images.map((imgSrc, index) => (
           <img key={index} src={imgSrc}  className="carousel-image2" />
         ))}
       </div>
     </div>


      {/* Footer */}
      <Footer />
    </div>
  );
};

export default TravelForm;

